import axios from "axios";

import { CredentialsDto } from "./dto";
import { mapCredentialsFromDto } from "./mappers";
import { Credentials, LoginPayload } from "./models";

import { apiClient } from "@shared/http/apiClient";

import { ApiResponse } from "@shared/http/types";

export class AuthError extends Error {}

function toAuthError(error: unknown): AuthError {
  if (!axios.isAxiosError(error)) {
    return new AuthError("Couldn't sign in. Check your connection.");
  }

  if (!error.response) {
    return new AuthError("Can't reach the server. Check your internet connection and try again.");
  }

  const status = error.response.status;

  if (status === 401 || status === 422) {
    return new AuthError("Invalid email or password");
  }

  return new AuthError(`Server error (${status}). Try again in a moment.`);
}

export async function login(payload: LoginPayload): Promise<Credentials> {
  let response;
  try {
    response = await apiClient.post<ApiResponse<CredentialsDto>>(
      "/v1/outlook/auth/login",
      payload,
      { skipAuthRefresh: true }
    );
  } catch (error) {
    throw toAuthError(error);
  }

  return mapCredentialsFromDto(response.data.payload.content);
}

export async function refresh(): Promise<Credentials> {
  const response = await apiClient.post<ApiResponse<CredentialsDto>>(
    "/v1/outlook/auth/refresh",
    null,
    { skipAuthRefresh: true }
  );
  return mapCredentialsFromDto(response.data.payload.content);
}

export async function logout(): Promise<void> {
  await apiClient
    .post("/v1/outlook/auth/logout", null, { skipAuthRefresh: true })
    .catch(() => undefined);
}
